import BrowserNotSupport from 'features/borswer-not-support/browser-not-support'

export default BrowserNotSupport
